import gql from 'graphql-tag';

const DELETE_DISCOUNT_MUTATION = gql`
  mutation deleteCategoryDiscount($_id: ID!) {
    deleteCategoryDiscount(_id: $_id)
  }
`;

export default DELETE_DISCOUNT_MUTATION;
